import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/secondadmin/base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { MasterService } from 'src/app/services/master/master.service';

@Component({
  selector: 'app-add-subscription-license-category',
  templateUrl: './add-subscription-license-category.component.html',
  styleUrls: ['./add-subscription-license-category.component.css']
})
export class AddSubscriptionLicenseCategoryComponent extends BaseComponent implements OnInit {
  customer_id;
  addCategoryForm: FormGroup;
  getCompanyobj: any = [];
  submitted = false;
  constructor(
    private formBuilder: FormBuilder,
    private clientsService: ClientService,
    private masterService: MasterService
  ) { super(); }

  ngOnInit(): void {
    this.customer_id = JSON.parse(sessionStorage.getItem('userData')).admin_customer_id;
    if (this.customer_id == 0) this.getCompany();
    this.addCategoryForm = this.formBuilder.group({
      selectedCompany: [(this.customer_id == 0) ? this.getDefaultCompanyId() : this.customer_id, Validators.required],
      category_name: ['', [Validators.required, Validators.maxLength(255)]]
    });
  }
  getCompany() {
    const self = this;
    this.clientsService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      const working = self.bindWorkingCompany(self.getCompanyobj);
      if (working && !self.addCategoryForm.value.selectedCompany) {
        self.addCategoryForm.patchValue({ selectedCompany: working });
      }
    }, error => {
      console.log(error);
    });
  }
  get f() { return this.addCategoryForm.controls; }
  addNewCategory() {
    this.submitted = true;
    if (this.addCategoryForm.invalid) {
      return;
    }
    const { selectedCompany } = this.addCategoryForm.value;
    this.ngxSpinnerService.show();
    this.masterService.addLicenseCategory(this.addCategoryForm.value, selectedCompany).subscribe(data => {
      this.ngxSpinnerService.hide();
      if (data.status) {
        this.toastrService.success('License category added successfully');
        this.router.navigateByUrl('/corporate/subscription-license-category-list');
      } else {
        this.toastrService.error(data.message);
      }
    }, error => {
      this.ngxSpinnerService.hide();
      this.toastrService.error(error.message);
    });
  }
}
